import React from 'react';
export function Testimonials() {
  return <section id="testimonios" className="py-10 bg-orange-50" data-id="element-362">
      <div className="container mx-auto px-4" data-id="element-363">
        <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-364">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3" data-id="element-365">
            Historias Reales
          </h2>
          <p className="text-xl text-gray-600" data-id="element-366">
            Familias como la tuya que ya están viendo resultados
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-367">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-368">
            <div className="flex items-center mb-3" data-id="element-369">
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Laura" className="w-12 h-12 object-cover rounded-full mr-4" data-id="element-370" />
              <div data-id="element-371">
                <h3 className="font-semibold text-gray-800" data-id="element-372">Laura</h3>
                <p className="text-gray-600 text-sm" data-id="element-373">Mamá en Texas</p>
                <div className="flex mt-1" data-id="element-374">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-375">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-376"></path>
                    </svg>)}
                </div>
              </div>
            </div>
            <blockquote className="text-gray-700 italic" data-id="element-377">
              "Gracias a esta guía, mis hijos ahora hablan español con sus
              abuelos cada fin de semana. Antes les daba pena… ahora están
              orgullosos."
            </blockquote>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-378">
            <div className="flex items-center mb-3" data-id="element-379">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Carlos" className="w-12 h-12 object-cover rounded-full mr-4" data-id="element-380" />
              <div data-id="element-381">
                <h3 className="font-semibold text-gray-800" data-id="element-382">Carlos</h3>
                <p className="text-gray-600 text-sm" data-id="element-383">Papá en Nueva York</p>
                <div className="flex mt-1" data-id="element-384">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-385">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-386"></path>
                    </svg>)}
                </div>
              </div>
            </div>
            <blockquote className="text-gray-700 italic" data-id="element-387">
              "Siempre pensé que hablar dos idiomas los iba a confundir. Hoy mi
              hijo tiene mejores notas y hasta enseña español a sus amigos."
            </blockquote>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-388">
            <div className="flex items-center mb-3" data-id="element-389">
              <img src="https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Daniela" className="w-12 h-12 object-cover rounded-full mr-4" data-id="element-390" />
              <div data-id="element-391">
                <h3 className="font-semibold text-gray-800" data-id="element-392">Daniela</h3>
                <p className="text-gray-600 text-sm" data-id="element-393">Mamá en Florida</p>
                <div className="flex mt-1" data-id="element-394">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-395">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-396"></path>
                    </svg>)}
                </div>
              </div>
            </div>
            <blockquote className="text-gray-700 italic" data-id="element-397">
              "Mis hijas estaban perdiendo el español completamente. Con estas
              estrategias, ahora leen cuentos en español todas las noches y me
              piden que les enseñe más palabras."
            </blockquote>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-398">
            <div className="flex items-center mb-3" data-id="element-399">
              <img src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Miguel" className="w-12 h-12 object-cover rounded-full mr-4" data-id="element-400" />
              <div data-id="element-401">
                <h3 className="font-semibold text-gray-800" data-id="element-402">Miguel</h3>
                <p className="text-gray-600 text-sm" data-id="element-403">Papá en California</p>
                <div className="flex mt-1" data-id="element-404">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-405">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-406"></path>
                    </svg>)}
                </div>
              </div>
            </div>
            <blockquote className="text-gray-700 italic" data-id="element-407">
              "Compré la guía hace 3 meses y la diferencia es increíble. Mi hijo
              de 7 años ahora habla con fluidez en ambos idiomas y hasta corrige
              mi inglés. La mejor inversión que he hecho."
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}